import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonApiResponse } from '@app/interfaces';
import { KanbanColumn } from '@app/interfaces/kanban-column.interface';
import { FunnelTemplateStage } from '@app/models/recruiting/funnel-template-stages.model';
import { FunnelTemplate } from '@app/models/recruiting/funnel-template.model';
import { ApplicantTrackerResources } from '../applicant-tracker.resource';

@Injectable()
export class FunnelTemplateService {
    constructor(private httpClient: HttpClient) {}

    duplicate(funnelTemplateId: number): Promise<JsonApiResponse<FunnelTemplate>> {
        const url = ApplicantTrackerResources.Duplicate.replace(':funnelTemplate', funnelTemplateId.toString());

        return this.httpClient.post<JsonApiResponse<FunnelTemplate>>(url, {}).toPromise();
    }

    saveTemplate(funnelTemplate: FunnelTemplate): Promise<FunnelTemplate> {
        return funnelTemplate.save();
    }

    async getFunnelTemplateStages(templateFunnelId: number): Promise<FunnelTemplateStage[]> {
        return await FunnelTemplateStage.where('atsFunnelTemplateId', templateFunnelId).get();
    }

    async loadFunnelTemplateStages(templateFunnelId: number): Promise<KanbanColumn[]> {
        const funnelTemplateStages: FunnelTemplateStage[] = await this.getFunnelTemplateStages(templateFunnelId);

        return funnelTemplateStages.map((funnelTemplateStage: FunnelTemplateStage) => {
            return {
                index: funnelTemplateStage.stageIndex,
                title: funnelTemplateStage.name,
                data: funnelTemplateStage,
            };
        });
    }

    async saveFunnelTemplateStages(
        funnelTemplateId: number,
        funnelTemplateStages: FunnelTemplateStage[]
    ): Promise<void> {
        await Promise.all(
            funnelTemplateStages.map((funnelStage: FunnelTemplateStage) => {
                funnelStage.atsFunnelTemplateId = funnelTemplateId;
                return funnelStage.save();
            })
        );
    }

    async updateFunnelTemplateColumnOrder(columns: KanbanColumn[]): Promise<void> {
        await Promise.all(
            columns
                .filter((column: KanbanColumn) => column.title !== 'Applied')
                .map((column: KanbanColumn) => {
                    const columnToUpdate: FunnelTemplateStage = column.data;

                    columnToUpdate.stageIndex = column.index;

                    return columnToUpdate.save();
                })
        );
    }

    async updateFunnelTemplateColumnName(update: { id: number; name: string }, columns: KanbanColumn[]): Promise<void> {
        const kanbanColumn: KanbanColumn = columns.find((column: KanbanColumn) => column.data.id === update.id);

        kanbanColumn.data.name = update.name;
        kanbanColumn.data.save();
    }

    async deleteTemplateFunnelStage(templateFunnelId: number, columns: KanbanColumn[]): Promise<KanbanColumn[]> {
        const kanbanColumn = columns.find((column: KanbanColumn) => column.data.id === templateFunnelId);

        await kanbanColumn.data.delete();

        return columns.filter((column: KanbanColumn) => {
            return column.data.id !== templateFunnelId;
        });
    }
}
